import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { CurrencyDetail, SymbolDetail } from "@ServerTypes/currency/currency.schema";

interface CurrencyState {
  currencyDetail?: CurrencyDetail;
  symbolDetail?: SymbolDetail;
  isDisable?: boolean;
}

const currencySlice = createSlice({
  name: "currencyDetails",
  initialState: {} as CurrencyState,
  reducers: {
    setCurrencyDetails: (_state: CurrencyState, action: PayloadAction<CurrencyState>) => ({
      ...action.payload,
    }),
  },
});

export const { setCurrencyDetails } = currencySlice.actions;

export const currencyDetails = currencySlice.reducer;

export default currencySlice.reducer;
